<template>
  <v-row
    class="pa-2 ma-0 d-flex footer bg-blue-grey-lighten-1 text-white position-sticky bottom-0 text-body-2 mx-auto"
  >
    <v-col class="footer-items flex-wrap d-flex ga-2 flex-sm-row flex-grow-1 align-center">
      <span class="footer-item d-flex px-2" style="border-right: 1px solid white"
        >@2026 Primerica</span
      ><span class="footer-item d-flex justify-center px-2" style="border-right: 1px solid white"
        ><a
          :href="$t(Translations.importantDisclosuresLink)"
          class="text-decoration-underline text-body-2 text-white"
          target="_blank"
        >
          {{ $t(Translations.importantDisclosuresText) }}</a
        ></span
      ><span class="footer-item d-flex px-2" style="border-right: 1px solid white"
        ><a
          :href="$t(Translations.termsOfUseLink)"
          class="text-decoration-underline text-body-2 text-white"
          target="_blank"
          >{{ $t(Translations.termsOfUseText) }}</a
        ></span
      ><span class="footer-item d-flex px-2"
        ><a
          :href="$t(Translations.privacyPolicyLink)"
          class="text-decoration-underline text-body-2 text-white"
          target="_blank"
          >{{ $t(Translations.privacyPolicyText) }}</a
        ></span
      >
    </v-col>
    <v-col cols="auto" class="d-flex align-center"
      ><img
        src="../assets/primerica-logo-white.png"
        alt="Primerica Logo"
        width="auto"
        height="30px"
        class="mx-auto"
    /></v-col>
  </v-row>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { Translations } from '@/i18n/models';

export default defineComponent({
  data() {
    return {
      Translations,
    };
  },
});
</script>
<style>
.footer {
  max-width: 900px !important;
}
</style>
